module.exports = __webpack_public_path__ + "img/text-width.8964af3f.svg";